// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__P3egO","menu":"Sidebar_menu__JMmnV"};